import React from 'react'
import PropTypes from 'prop-types'
import CoursesMenuSection from './CoursesMenuSection'
import CourseNavUnit from './CourseNavUnit'
import CourseNavItem from './CourseNavItem'
import { Nav, NavDropdown } from 'react-bootstrap'
import { decodeHtml } from '../../utils'

const App = props => {
  const navEl = React.createRef(null)
  const courseEl = React.createRef(null)
  const downArrow = e => {
    let elRef = ''

    e.target.id === 'coursesMenu' ? (elRef = courseEl) : (elRef = navEl)

    e.keyCode === 40 ? elRef.current.focus() : null
  }

  let courseTitle = (
    <span>
      {decodeHtml(props.courseTitle)}{' '}
      <span className="fa-fw far fa-angle-down" />
    </span>
  )
  let contentTitle = (
    <span>
      {decodeHtml(props.contentTitle)}{' '}
      <span className="fa-fw far fa-angle-down" />
    </span>
  )

  return (
    <React.Fragment>
      <Nav className="d-inline-block navbar-nav">
        <NavDropdown
          title={courseTitle}
          id="coursesMenu"
          onKeyDown={downArrow}
          noCaret
        >
          <CoursesMenuSection
            ref={courseEl}
            books={props.books}
            section="My Courses"
          />
          <CoursesMenuSection
            ref={props.books.length > 0 ? null : courseEl}
            books={props.archivedBooks}
            section="Archived Courses"
          />
        </NavDropdown>
        <NavDropdown
          title={contentTitle}
          id="navMenu"
          onKeyDown={downArrow}
          noCaret
        >
          <React.Fragment>
            <CourseNavItem
              href={`/reader/web/${props.coursenum}/`}
              itemTitle="Title Page"
              paddingLeft="10px"
              ref={navEl}
            />
            {props.contents.map(item => {
              return (
                <CourseNavUnit
                  unitTitle={item.title}
                  unitActive={item.id === props.activeContent}
                  modulesAndLinks={item.modulesAndLinks}
                  unitId={item.id}
                  key={item.id}
                  coursenum={props.coursenum}
                  isLocked={item.isLocked}
                />
              )
            })}
          </React.Fragment>
        </NavDropdown>
      </Nav>
    </React.Fragment>
  )
}

App.propTypes = {
  courseTitle: PropTypes.string,
  contentTitle: PropTypes.string,
  books: PropTypes.array,
  archivedBooks: PropTypes.array,
  contents: PropTypes.array,
  activeContent: PropTypes.bool,
  coursenum: PropTypes.string,
}

export default App
